import { useMemo } from "react";
import Breadcrumbs from "../../../components/re-usable/breadcrumbs/breadcrumbs";
import GetSocialMedia from "../../../components/re-usable/get-social-media";

type layOutTypes = {
  breadcrumbPath: string;
  isBreadcrumbpath: boolean;
  showSocialMedia?: boolean;
};
const LayoutTop = (props: layOutTypes): JSX.Element => {
  const cachedSocialMedia = useMemo(() => <GetSocialMedia />, []);
  return (
    <div className="container">
      <div className="page-tools row">
        <div className="col-sm-8 col-lg-9">
          {props.isBreadcrumbpath ? <Breadcrumbs breadcrumbPath={props.breadcrumbPath} /> : ""}
          {/* <Breadcrumbs breadcrumbPath={props.breadcrumbPath} /> */}
        </div>
        {(props.showSocialMedia === undefined || props.showSocialMedia) && <div className="col-sm-4 col-lg-3">{cachedSocialMedia}</div>}
      </div>
    </div>
  );
};

export default LayoutTop;
